module.exports = __webpack_public_path__ + "img/img_index_zi_jiaoxue@2x.05e9bcac.png";